// Next hands a repeated search param over as an array; each entry is a comma list.
export default function getQueryList(value) {
  return [value]
    .flat()
    .filter(entry => typeof entry === 'string')
    .flatMap(entry => entry.split(','))
    .map(entry => entry.trim());
}
